import { MeetingActions } from '../../actions/meeting.actions';
import { MeetingMutations } from '../../mutations/meeting.mutations';
import CourseActions from '@/content/actions/course.actions';
import CourseMutations from '@/content/mutations/course.mutations';

export const TEACHER_PORTAL_STORE_NAME = 'TeacherPortalStore';

export const TEACHER_PORTAL_ACTIONS_NAMES = {
  SET_WIDGET_FULLSCREEN: 'setWidgetFullScreen',
};

export const TEACHER_PORTAL_STORE = {
  NAME: TEACHER_PORTAL_STORE_NAME,
  MUTATIONS: {},
  ACTIONS: {
    SET_WIDGET_FULLSCREEN: `${TEACHER_PORTAL_STORE_NAME}/${TEACHER_PORTAL_ACTIONS_NAMES.SET_WIDGET_FULLSCREEN}`,
  }
}

export const TeacherPortalStore = {
  namespaced: true,
  state: {
    meetings: [],
    courses: [],
    course: {},
    currentLessons: [],
    usersOrganization: [],
    homeworks: [],
    tasks: [],
    userId: null,
    sections: [],
    coursesAlreadyLoad: false,
    page: null,
    widgetFullScreen: null
  },
  mutations: {
    setMeetings: MeetingMutations.setMeetings,
    removeMeeting: MeetingMutations.removeMeeting,
    createMeeting: MeetingMutations.createMeeting,
    updateMeeting: MeetingMutations.updateMeeting,
    setMembersMeeting: MeetingMutations.setMembersMeeting,
    setCourses: CourseMutations.setCourses,
    setUserInfo: MeetingMutations.setUserInfo,
    setUsersOrganization: MeetingMutations.setUsersOrganization,
    setCourseContent: CourseMutations.setCourseContent, /* Deprecated */
    setWidgetFullScreen: (state, value) => {
      state.widgetFullScreen = value;
    },
    initState: CourseMutations.initTeacherPortalState,
  },
  actions: {
    getCourses: CourseActions.getCourses,
    getCreatorInfo: MeetingActions.getCreatorInfo, 
    getUsersOrganization: MeetingActions.getUsersOrganization,
    getContentByEditor: CourseActions.getContentByEditor,
    /* Meetings */
    getMeetingsOfStudent: MeetingActions.getMeetingsOfStudent,
    getMeetingsOfTeacher: MeetingActions.getMeetingsOfTeacher,
    removeMeeting: MeetingActions.removeMeeting,
    createMeeting: MeetingActions.createMeeting,
    getMembersMeeting: MeetingActions.getMembersMeeting,
    setMembersMeeting: MeetingActions.setMembersMeeting,
    updateMeeting: MeetingActions.updateMeeting
  }
};
